import React, { useRef, useState } from 'react';

/**
 * Mobile-style bottom sheet (85dvh), aligned with WhiteLabel /mobile product sheets.
 */
const MobileBottomSheet = ({ open, onOpenChange, title, children, zIndexClass = 'z-[100]' }) => {
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startYRef = useRef(0);

  if (!open) return null;

  const beginDrag = (clientY) => {
    setIsDragging(true);
    startYRef.current = clientY;
  };

  const updateDrag = (clientY) => {
    if (!isDragging) return;
    const delta = Math.max(0, clientY - startYRef.current);
    setDragY(delta);
  };

  const endDrag = () => {
    if (!isDragging) return;
    const shouldClose = dragY > 100;
    setIsDragging(false);
    setDragY(0);
    if (shouldClose) onOpenChange(false);
  };

  return (
    <div className={`fixed inset-0 ${zIndexClass} flex flex-col justify-end pointer-events-none`}>
      <button
        type="button"
        className="absolute inset-0 bg-black/40 pointer-events-auto"
        aria-label="Close"
        onClick={() => onOpenChange(false)}
      />
      <div
        className="relative pointer-events-auto flex flex-col h-[85dvh] max-h-[85vh] w-full max-w-[430px] mx-auto rounded-t-2xl bg-[#e8e8ea] shadow-[0_-8px_30px_rgba(0,0,0,0.12)] overflow-hidden"
        style={{
          transform: `translateY(${dragY}px)`,
          transition: isDragging ? 'none' : 'transform 180ms ease-out',
        }}
      >
        <div
          className="flex justify-center pt-2 pb-1 flex-shrink-0 touch-none cursor-grab active:cursor-grabbing"
          onPointerDown={(e) => {
            e.currentTarget.setPointerCapture?.(e.pointerId);
            beginDrag(e.clientY);
          }}
          onPointerMove={(e) => updateDrag(e.clientY)}
          onPointerUp={endDrag}
          onPointerCancel={endDrag}
        >
          <div className="h-1.5 w-10 rounded-full bg-neutral-400" aria-hidden />
        </div>
        <div className="flex items-start justify-between gap-2 px-4 pr-10 pt-1 pb-2 flex-shrink-0 border-b border-neutral-300/40">
          {title ? (
            <h2 className="text-lg font-bold text-gray-800 leading-snug m-0 flex-1 text-center pl-6">
              {title}
            </h2>
          ) : (
            <span className="flex-1" />
          )}
        </div>
        <div className="flex-1 overflow-y-auto min-h-0 px-4 py-3 pb-8 public-dish-scroll">{children}</div>
      </div>
    </div>
  );
};

export default MobileBottomSheet;
